import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HostState, Game } from "../../types";

const initialState: HostState = {
  gamelist: {},
  whitelist: {},
  blacklist: {},
};

const hostSlice = createSlice({
  name: "host",
  initialState,
  reducers: {
    setHostGames: (state, action: PayloadAction<Record<string, Game>>) => {
      state.gamelist = action.payload;
    },
    setWhitelist: (state, action: PayloadAction<Record<string, any>>) => {
      state.whitelist = action.payload;
    },
    setBlacklist: (state, action: PayloadAction<Record<string, any>>) => {
      state.blacklist = action.payload;
    },
  },
});

export const { setHostGames, setWhitelist, setBlacklist } = hostSlice.actions;
export default hostSlice.reducer;
